/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ShoppingWithWrapper_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"AllShoppersModal_viewer" | "ShoppingWithGrid_viewer">;
    readonly " $refType": "ShoppingWithWrapper_viewer";
};
export type ShoppingWithWrapper_viewer$data = ShoppingWithWrapper_viewer;
export type ShoppingWithWrapper_viewer$key = {
    readonly " $data"?: ShoppingWithWrapper_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"ShoppingWithWrapper_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "ShoppingWithWrapper_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "AllShoppersModal_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "ShoppingWithGrid_viewer",
      "args": null
    }
  ]
};
(node as any).hash = '6426930c72d7451ac9da7b9482f762bd';
export default node;
